import { useEffect } from 'react';
import { applyGardenMeta } from './pageMeta';

/**
 * ページごとに呼ぶ。titleSuffix を渡すと「◯◯ | 園名」の形になる。
 * 省略すると受入マニュアルの既定文になる。
 */
export function useGardenMeta(titleSuffix?: string, description?: string) {
  useEffect(() => {
    applyGardenMeta({ titleSuffix, description });
  }, [titleSuffix, description]);
}
